import { render, staticRenderFns } from "./ResourceUpdate.vue?vue&type=template&id=7c54a0be&scoped=true"
import script from "./ResourceUpdate.vue?vue&type=script&lang=js"
export * from "./ResourceUpdate.vue?vue&type=script&lang=js"
import style0 from "./ResourceUpdate.vue?vue&type=style&index=0&id=7c54a0be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c54a0be",
  null
  
)

export default component.exports